// The registered entry to an AppDialog's close path (components/AppDialog.js
// v2) — for code OUTSIDE the dialog's own handlers: a consumer's custom
// Cancel, a "Done" that closes after saving, a row action inside the body.
//
//   el.call('appDialogCloseNearest')                        // Close, Cancel
//   el.call('appDialogCloseNearest', { fromBackdrop: true }) // veil semantics
//
// `this` is the element that asks. The logic lives ONCE, on the dialog
// itself (`AppDialog.scope.closeNearest`, reached through the scope chain from
// any descendant): the nearest dialog root; a backdrop click inert while the
// dialog is `dirty` (DESIGN_SPEC §6.7 — no silent loss of unsaved input);
// `closeCall` for a host-driven dialog; otherwise `stateKey` (+ `extraClose`)
// nulled on the root state. The dialog's own Esc / veil / Close / Cancel call
// the scope directly, so they work even where this function is not
// registered (a standalone module's sharedLibraries.js).
//
// Returns true when a close was requested, false when nothing closed —
// including when `this` is not inside an AppDialog.
export function appDialogCloseNearest(opts) {
  const el = this
  const scope = el && el.scope
  if (!scope || typeof scope.closeNearest !== 'function') return false
  return scope.closeNearest(el, opts)
}
